export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0xc65a0e2a410Ca52B0a5b57b1d239a857b3cd618b",
  capRiskStewardFactory: "0xec1b75024AFDe61492b514489DA6eEB02844c1Bb",
  edgeFactory: "0x2BeB74b6845Ec05A78F642262CaA8e7e3f00C42a",
  edgeFactoryPerspective: "0xdcE47c28B8B34E0370b1DAe8067B8b2b9D24E3df",
  escrowedCollateralPerspective: "0xc8d904FE94b65612AED5A73203C0eF8f3A0308C0",
  eulerEarnFactoryPerspective: "0xC19CeA1886Bc1876A85572bE4041082808936B26",
  eulerEarnGovernedPerspective: "0xb42a9DD67bD6b48940A862C0f0c8a6C5DD26582f",
  eulerEarnPublicAllocator: "0x4148f90e03facFF8D2d5EFb475E36F94b4Ab4994",
  eulerUngoverned0xPerspective: "0xA3B087CC842749e2dC251DE7Ea1967a936C5335a",
  eulerUngovernedNzxPerspective: "0x246667c6f8119E64b5d88cC963Ef9d4391C77C81",
  evkFactoryPerspective: "0x832ca1e2FCBedf717b9C71C00Dd26805e3bE4270",
  externalVaultRegistry: "0x28aF9ba9152832A5B22f51510556801baDa96bBC",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xbF939812A673CB088f466d610c4b120b13eA5fAB",
  feeFlowControllerUtil: "0x79af541a66DDe9b177e76839344Ea9DC2ff746aB",
  fixedCyclicalBinaryIRMFactory: "0x13697701ff322367417469AB0497ea9C38b8A875",
  governedPerspective: "0x74f9fD22aA0Dd5Bbf6006a4c9818248eb476C50A",
  governorAccessControlEmergencyFactory:
    "0x1Fa5297507c725f91479f3fa033a81c7f2E2d52D",
  irmRegistry: "0xe47732e6BAB2ae02D35879C061ac1751e7BE7aF9",
  kinkIRMFactory: "0x2940Df424dBDc697de86212eAb665721B6d32338",
  kinkyIRMFactory: "0x054bF58ec4531D6be9674558871f89C5867c6BfB",
  oracleAdapterRegistry: "0x5f81DdA3f9155c31f552ABC3eb4B47676ba09680",
  oracleRouterFactory: "0xf0125F638c7134e6997e4F825b78c324CcF289aF",
  swapVerifier: "0x77C9B0E7Ac0405797F04E5230Ed0A54DB39f98f0",
  swapper: "0x1480Cfff566f27BbB2AEAd6eeABEc4BA068e5405",
  termsOfUseSigner: "0x47613A45370f7C7021025Bad0DAe65be213678b9",
} as const
